import React from "react";
import { WidgetDetails, Title, BlogImg } from "../../assets/styled/BlogStyle";

const Blog_4 = () => {
  return (
    <>
      <BlogImg src="https://www.raktherm.com/images/blog4.jpg" alt="blog-1" />
      <Title>
        RAKtherm Emerges as an Industry Leader in Addressing Drainage Problems
        and Offering Solutions
      </Title>
      <WidgetDetails>
        RAKtherm Multilayer Drainage Piping Solutions has thoroughly understood
        piping systems to distribute waste efficiently. Our in-depth research
        and development have allowed us to develop a contemporary approach to
        analyzing piping networks over the past 60 years. Since we are the
        leading innovator and provider of piping solutions in the industry, we
        are dedicated to providing high-quality goods and services.
      </WidgetDetails>

      <Title>Why RAKtherm DWV Systems (Drain, Waste, Vent)?</Title>
      <WidgetDetails>
        One of RAKtherm's most recent innovations is the DWV Systems (Drainage,
        Sewerage, Waste, and Vent). Compared to conventional pipes, this modern,
        three-layer pipe is more durable, composed of new-generation premium
        materials, and has solid walls.
      </WidgetDetails>

      <Title>Ground-breaking RNP Technology from Raktherm</Title>
      <WidgetDetails>
        A consistent middle layer structure, with individual cells, ensures
        increased mechanical properties. In contrast, an inner and outer layer
        are integrated to create a "sandwich construction" that surpasses noise
        reduction, durability, flexibility, and longevity requirements.
      </WidgetDetails>

      <Title>
        The Rarefied Concept for RAKtherm's Noise-Reduction Technology
      </Title>
      <WidgetDetails>
        The newest line of PVC-U piping systems from RAKtherm has their
        Noise-Reduction Technology. One of the most important features of a
        building's interior design is noise control. Our expertise in pipe
        engineering can help to fulfil the growing demand for customers'
        criteria connected to well-being as building technology gets more
        intricate and technically demanding.
      </WidgetDetails>

      <WidgetDetails>
        The pipes are constructed using multiple layers of PVC-U for Sound
        Attenuation System applications that are intended to reduce
        environmental noise. RAKtherm satisfies the German standard DIN 4109 and
        EN 14366, demonstrating its excellent efficacy in sewage system noise
        reduction.
      </WidgetDetails>

      <Title>
        RAKtherm Triple-Sealing-Lip Solutions are Perfectly Engineered for PVC
        Sewer Pipe Systems
      </Title>
      <WidgetDetails>
        An integrated seal for plastic pipe systems for above- and below-ground
        drainage and sewage systems are provided by the multi-layer reinforced
        rubber junction.
      </WidgetDetails>
      <WidgetDetails>
        The triple-sealing-lip solutions from RAKtherm now outperform the
        competition because they provide a secure seal throughout a wide range
        of pipe-joint level tolerances while requiring less jointing force.
      </WidgetDetails>

      <Title>The RAKtherm Triple-Sealing-Lip Concept</Title>
      <WidgetDetails>
        The pipe maker places a DIN lockTM, a combined lip and compression seal,
        in the socket. Any allowable fluctuation in the groove will be absorbed
        by the seal.
      </WidgetDetails>

      <Title>Geometric Design for Functionality (GDFF)</Title>
      <WidgetDetails>
        The innovative design retains the seal securely in the proper position
        throughout pipe transportation and joint assembly thanks to a flexible
        thermoplastic elastomeric sealing element that is linked to a
        polypropylene retaining ring.
      </WidgetDetails>
      <WidgetDetails>
        The RAKtherm triple-sealing-lip seal is engineered to have a low
        assembly force at both the minimum and maximum gap, allowing for good
        compression on each of its three lips. Maximum compression can be used
        during assembly without encountering any issues.
      </WidgetDetails>
    </>
  );
};

export default Blog_4;
